// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right__border[data-v-eda2c466]{border-right:1px solid #c4c4c4}.score__border[data-v-eda2c466]{border-top:2px solid #c4c4c4;border-bottom:2px solid #c4c4c4}", ""]);
// Exports
module.exports = exports;
